// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4386":"css/app.6703","6685":"css/admin-app.6703"}[chunkId] + ".css";
};